import { connect } from 'react-redux'
import { IGlobalState } from '../../../Root/store/appReducer'
import {
  getCurrentGoalActivityList,
  getCurrentGoalActivityListClear,
  setGroupSum,
} from '../../../views/Activity/store/ActivityActions'
import {
  IYumGoalRankingHeaderDispatchProps,
  IYumGoalRankingHeaderProps,
  YumGoalRankingHeader,
} from './YumGoalRankingHeader'

// Using Omit utility type to exclude redux-connected props from the interface
//type OwnProps = Omit<IYumGoalRankingHeaderProps, 'userIsInActivityList'>
type OwnProps = IYumGoalRankingHeaderProps

const mapStateToProps = (state: IGlobalState, ownProps: OwnProps): IYumGoalRankingHeaderProps => {
  return {
    ...ownProps,
  }
}

const mapDispatchToProps: IYumGoalRankingHeaderDispatchProps = {
  getCurrentGoalActivityList,
  getCurrentGoalActivityListClear,
  setGroupSum,
}

export default connect(mapStateToProps, mapDispatchToProps)(YumGoalRankingHeader)
